import React from 'react';
import { useEffect, useState } from 'react';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../Nav/Routes';

function Events() {
    const [listOfEvents, setListOfEvents] = useState([]);
    let navigate = useNavigate();

    useEffect(() => {
        axios.get("https://bntserver.bntfoundation.com/EventGet.php").then((response) => {
            setListOfEvents(response.data);
            console.log(response.data);
        })
    }, [])

    const handleClickTop = () => {
        window.scrollTo(0, 330);
    };
    const readMore = (id) => {
        handleClickTop();
        // You can implement event detail navigation here if needed
        // navigate(`/EventDetail/${id}`);
    }
    return (
        <div>
            <div className="hero page-inner overlay"
                style={{ backgroundImage: `url('../../Content/img/slide/BNT5.jpg')` }}>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-9 text-center mt-5">
                            <h1 className="heading" data-aos="fade-up">Events</h1>
                            <nav aria-label="breadcrumb"
                                data-aos="fade-up"
                                data-aos-delay="200">
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gray-back">
                <div className="container py-5">
                    <div className="row justify-content-center text-center py-3">
                        <div className="col-lg-5">
                            <h2 className="font-weight-bold heading text-primary " data-aos="fade-up">
                                Latest Events
                            </h2>
                            <h6 data-aos="fade-up" data-aos-delay="100">
                                Stay informed about our latest events
                            </h6>
                        </div>
                    </div>
                    <div className="row ">
                        {listOfEvents.map((value, key) => {
                            const dateString = value.eventdate; // e.g. "2025-02-10"

                            const [year, month, day] = dateString.split('-');
                            const eventDate = new Date(Date.UTC(year, month - 1, day));

                            // Format day
                            const formattedDay = eventDate.getUTCDate();

                            // Format month
                            const formattedMonth = eventDate.toLocaleString('en-CA', { month: 'long', timeZone: 'UTC' });

                            // Format year
                            const formattedYear = eventDate.getUTCFullYear();

                            return (
                                <div className="col-12 col-md-6 col-lg-4 my-4" data-aos="fade-up" key={key}>
                                    <div className="box-news">
                                        <div className="link-acent">
                                            <div className="imageHolder" style={{
                                                backgroundImage: `url(https://bntserver.bntfoundation.com/${value.image ? value.image.replace(/\\/g, '/') : ''})`
                                            }}></div>
                                        </div>
                                        <div className="NewsDContainer">
                                            <div className="newsSidePanel">
                                                <span>{formattedDay}</span>
                                                <p>{formattedMonth}</p>
                                                <p>{formattedYear}</p>
                                            </div>
                                            <div className="newsContent">
                                                <div className="link-acent">
                                                    <h6 className="ola">{value.title}</h6>
                                                </div>
                                                <p>
                                                    {value.desc && value.desc.length > 100
                                                        ? `${value.desc.substring(0, 100)}...`
                                                        : value.desc}
                                                </p>
                                                {/* <div className="link-acent">
                                                    Read more
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Events;
